/*
 * File: IconButton.styles.js
 * Project: lets-talk-web
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:59 PM
 * Copyright © 2022 Let's Talk. All rights reserved.
 *
 * Last Modified: April 8, 2024 at 10:00 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const Button = styled.button`
 	display: flex;
 	appearance: none;
 	border: none;
 	background-color: transparent;
 	color: inherit;
 	cursor: pointer;

 	&:hover {
	 	opacity: 0.8;
 	}

 	svg {
	 	width: ${({ size }) => size}rem !important;
	 	height: ${({ size }) => size}rem !important;
 	}
`;
